/* eslint-disable react/prop-types */
import classes from "./load-pdf.module.scss";
import classNames from "classnames";
import Flex from "@/components-library/layout/flex";
import * as admin from "@/views/admin-dashboard/admin.slice";
import Label from "@/components-library/widgets/label";

import Spinner from "@/components-library/widgets/spinner/spinner";
import CreateAnnouncement from "../create-announcement";
function LoadTechnicalPdf({
  onDrag,
  handleDrop,
  onChange,
  onButtonClick,
  dragActive,
  inputRef,
  status,
  loadedAnnouncement,
}) {
  if (
    status !== admin.Status.IDLE &&
    status !== admin.Status.SUCCESS &&
    status !== admin.Status.CREATED
  ) {
    return <Spinner />;
  } else {
    return (
      <Flex
        align="center"
        direction="column"
        justify="center"
        className={classes.loadPdf}
      >
        {!loadedAnnouncement && (
          <>
            <Label tag="h4" weight="bold" color="secondary">
              Carica una scheda tecnica
            </Label>

            <form
              className={classes.formFileUpload}
              onDragEnter={onDrag}
              onSubmit={(e) => e.preventDefault()}
            >
              <input
                ref={inputRef}
                type="file"
                className={classes.inputFileUpload}
                multiple={true}
                onChange={onChange}
              />
              <label
                className={classNames(classes.labelFileUpload, {
                  [classes.dragActive]: dragActive,
                })}
                htmlFor="input-file-upload"
              >
                <div>
                  <button
                    className={classes.uploadButton}
                    onClick={onButtonClick}
                  >
                    Seleziona o trascina un file
                  </button>
                  <br></br>
                </div>
              </label>
              {dragActive && (
                <div
                  className={classes.dragFileElement}
                  onDragEnter={onDrag}
                  onDragLeave={onDrag}
                  onDragOver={onDrag}
                  onDrop={handleDrop}
                ></div>
              )}
            </form>
          </>
        )}
        {loadedAnnouncement && (
          <CreateAnnouncement startAnnoucement={loadedAnnouncement} />
        )}
      </Flex>
    );
  }
}
export default LoadTechnicalPdf;
